import { Tooltip } from "antd"
import SidebarToggleIcon from "components/new-stuff/ui/SidebarToggleIcon"
import { useSideNavigationStore } from "stores/side-navigation"

/**
 * Collapse / expand button. Lives at the left of the top bar, the desktop
 * counterpart of the mobile hamburger, so it never overlaps the panel.
 */
const SideNavToggle = () => {
  const { collapsed, toggleCollapsed } = useSideNavigationStore()

  return (
    <Tooltip
      title={collapsed ? "Open sidebar" : "Close sidebar"}
      placement="right"
      mouseEnterDelay={0.15}
    >
      <button
        type="button"
        aria-label={collapsed ? "Expand navigation" : "Collapse navigation"}
        aria-expanded={!collapsed}
        onClick={toggleCollapsed}
        className="hidden md:flex h-8 w-8 shrink-0 self-center items-center justify-center rounded-md text-neutral500 hover:bg-neutral-100 hover:text-padeBlack"
      >
        <SidebarToggleIcon
          flipped={!collapsed}
          size={20}
        />
      </button>
    </Tooltip>
  )
}

export default SideNavToggle
